import type { FC } from 'react';

import { ProductsCarouselSliderOneBlockSkeleton as ProductsCarouselSliderOneBlockSkeletonV3 } from '~/components/isolated/CategoryBlocks/ProductsCarouselSliderOneBlock';
import {
  type LoadMore,
  useLoadMoreSentinel,
} from '~/hooks/useLoadMoreSentinel';

interface ScrollPaginationSkeletonProps {
  onLoadMore: LoadMore;
  className?: string;
}

export const ScrollPaginationSkeleton: FC<ScrollPaginationSkeletonProps> = ({
  onLoadMore,
  className,
}) => {
  const ref = useLoadMoreSentinel<HTMLDivElement>(onLoadMore);

  return (
    <ProductsCarouselSliderOneBlockSkeletonV3 ref={ref} className={className} />
  );
};
